import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { getInitialBrandQueryParams } from "./BrandsUIHelpers";

const BRAND_SEARCH_FILTER_KEY = "brands_search_filter";
const SORTABLE_BRAND_FIELDS = ["id", "name", "is_featured"];

const getPersistedSortParams = () => {
  const searchFilter = JSON.parse(localStorage.getItem(BRAND_SEARCH_FILTER_KEY)) || {};
  const sortField = searchFilter.sortBy || searchFilter.sortField;
  const sortOrder = searchFilter.sortOrder === "asc" ? "asc" : searchFilter.sortOrder === "desc" ? "desc" : "";

  if (!SORTABLE_BRAND_FIELDS.includes(sortField) || !sortOrder) {
    return {};
  }

  return {
    sortBy: sortField,
    sortField,
    sortOrder,
  };
};
const BrandsUIContext = createContext();
export function useBrandsUIContext() {
  return useContext(BrandsUIContext);
}

export const BrandsUIConsumer = BrandsUIContext.Consumer;

export function BrandsUIProvider({ brandsUIEvents, children }) {
  const [ids, setIds] = useState([]);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(false);
  const [queryParams, setQueryParamsBase] = useState({ ...getInitialBrandQueryParams, ...getPersistedSortParams() });
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }
      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }
      return nextQueryParams;
    });
  }, []);

  const value = {
    ids,
    setIds,
    brands,
    setBrands,
    loading,
    setLoading,
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    newBrandButtonClick: brandsUIEvents.newBrandButtonClick,
    editBrand: brandsUIEvents.editBrand,
    openBrandExportDialog: brandsUIEvents.openBrandExportDialog,
    createProductForBrand: brandsUIEvents.createProductForBrand,
  };
  return <BrandsUIContext.Provider value={value}>{children}</BrandsUIContext.Provider>;
}
